import { Controller } from 'stimulus';
import Rails from '@rails/ujs';
import { put } from '@rails/request.js';
import Croppie from 'croppie';

let cropper = null;

export default class extends Controller {
	static targets = ["avatar"]

	connect() {
		const cropperDiv = document.getElementById("crop_avatar")
		if (!cropper) {
			cropper = new Croppie(cropperDiv, {
				viewport: {
					width: 300,
					height: 300,
					type: "circle"
				},
				boundary: {
					width: 650,
					height: 350
				}
			})
		}
	}

	async save() {
		cropper.result({
			type: "blob"
		}).then((avatarBlob) => {
			const formData = new FormData()
			formData.append("user[avatar]", avatarBlob)

			put("/update_avatar", {body: formData}).then(r => {
				const modal = document.getElementById("cropper-modal")
				modal.classList.remove("show");
				window.location.reload();
			})
		})
	}

	upload() {
		const reader = new FileReader();
		reader.addEventListener("load", () => {
			cropper.bind({
				url: reader.result
			})
		});
		reader.readAsDataURL(this.avatarTarget.files[0]);

		const modal = document.getElementById("cropper-modal")
		modal.classList.add("show");
	}

	closeModal() {
		const modal = document.getElementById("cropper-modal")
		modal.classList.remove("show");
	}
}
